import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import React, { useEffect, useLayoutEffect, useRef } from 'react';
import i18n from 'i18next';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import Card from '../ui/card';
var t = i18n.getFixedT(null, 'traffic-statistic');
var AreaTotalChangeCard = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  });

  _objectDestructuringEmpty(_useSelector);

  var dispatch = useDispatch();
  var chartXY = useRef();
  var roadSectionChartData = props.roadSectionChartData;

  var handleChartData = function handleChartData(data) {
    if (_.isEmpty(data)) return [];

    var calTime = function calTime(t) {
      return t < 10 ? '0' + t : t;
    };

    var colors = {
      'noData': am4core.color("#ccc"),
      'Light': am4core.color("#55c836"),
      'Heavy': am4core.color("#ffbc3c"),
      'Jam': am4core.color("#ff3c3c")
    };
    var chartData = [];
    data.map(function (el) {
      el.stats.map(function (o) {
        var obj = {};
        obj.category = el.roadSectionName;
        obj.time = calTime(o.hour) + ':' + calTime(o.minute);
        obj.color = colors[o.avgStatus ? o.avgStatus : 'noData'];
        chartData.push(obj);
      });
    });
    return chartData;
  };

  useLayoutEffect(function () {
    chartXY.current = am4core.create('area-analytics-chart', am4charts.XYChart);
    chartXY.current.maskBullets = false;
    var xAxis = chartXY.current.xAxes.push(new am4charts.CategoryAxis());
    var yAxis = chartXY.current.yAxes.push(new am4charts.CategoryAxis());
    xAxis.dataFields.category = 'time';
    yAxis.dataFields.category = 'category';
    xAxis.renderer.grid.template.disabled = true;
    xAxis.renderer.minGridDistance = 40;
    yAxis.renderer.grid.template.disabled = true;
    yAxis.renderer.inversed = true;
    yAxis.renderer.minGridDistance = 30;
    var series = chartXY.current.series.push(new am4charts.ColumnSeries());
    series.dataFields.categoryX = 'time';
    series.dataFields.categoryY = 'category';
    series.dataFields.value = 'value';
    series.sequencedInterpolation = true;
    series.defaultState.transitionDuration = 3000;
    series.columns.template.propertyFields.fill = 'color';
    var bgColor = new am4core.InterfaceColorSet().getFor('background');
    var columnTemplate = series.columns.template;
    columnTemplate.strokeWidth = 1;
    columnTemplate.strokeOpacity = 1;
    columnTemplate.stroke = bgColor;
    columnTemplate.tooltipText = '{category}: {time}';
    columnTemplate.width = am4core.percent(100);
    columnTemplate.height = am4core.percent(100); // insert chart data

    chartXY.current.data = handleChartData(roadSectionChartData); // Legend

    var legend = new am4charts.Legend();
    legend.parent = chartXY.current.chartContainer;
    legend.itemContainers.template.clickable = false;
    legend.itemContainers.template.focusable = false;
    legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default;
    legend.align = "bottom";
    legend.data = [{
      "name": t('lbl-no-data'),
      "fill": am4core.color("#ccc")
    }, {
      "name": t('lbl-idle'),
      "fill": am4core.color("#55c836")
    }, {
      "name": t('lbl-busy'),
      "fill": am4core.color("#ffbc3c")
    }, {
      "name": t('lbl-congestion'),
      "fill": am4core.color("#ff3c3c")
    }]; // hide amcharts4 logo

    var eles = document.querySelectorAll('[aria-labelledby$=-title]');
    eles.forEach(function (ele) {
      ele.style.visibility = 'hidden';
    });
    return function () {
      chartXY.current.dispose();
    };
  }, [JSON.stringify(roadSectionChartData)]);
  return /*#__PURE__*/React.createElement(Card, {
    className: "analytics-chart-card",
    title: t('lbl-area-analytics'),
    enableFullScreen: true
  }, /*#__PURE__*/React.createElement("div", {
    id: "area-analytics-chart",
    className: "chart"
  }));
});
export default AreaTotalChangeCard;